import axios from "axios"
import { refreshToken } from "../helpers/RequestExecutor";

export const getActiveGames = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/players/exists`, {
            headers: {
                "Authorization": "Bearer "+localStorage.getItem("token")
            }
        });
        return response.data;
    } catch(e) {
        if(e.status === 401) {
            await refreshToken();
            return await getActiveGames();
        } else {
            return e.response?.data || {};
        }
    }
}

export const getPlayerInfo = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/players/info`, {
            headers: {
                "Authorization": "Bearer "+localStorage.getItem("token")
            }
        });
        return response.data;
    } catch(e) {
        if(e.status === 401) {
            await refreshToken();
            return await getPlayerInfo();
        } else {
            return e.response?.data || {};
        }
    }
}

export const getAllPlayerInfo = async (showStocks) => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/players?showStocks=${showStocks}`, {
            headers: {
                "Authorization": "Bearer "+localStorage.getItem("token")
            }
        });
        return response.data;
    } catch(e) {
        if(e.status === 401) {
            await refreshToken();
            return await getAllPlayerInfo(showStocks);
        } else {
            return e.response.data;
        }
    }
}